import gql from 'graphql-tag';

export const SEND_APPLICATION_LINK = gql`
  mutation ($accountId: ID!, $policyId: String!) {
    sendApplicationLink: sendApplicationUrl(accountId: $accountId, policyId: $policyId) {
      email
    }
  }
`;
